export default {
  'name': '@okta/okta-react',
  'version': '3.0.7'
};
